import { render, staticRenderFns } from "./AssignmentCar.vue?vue&type=template&id=a8685396&lang=true&"
import script from "./AssignmentCar.vue?vue&type=script&lang=js&"
export * from "./AssignmentCar.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentCar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports